import { Component, ChangeDetectionStrategy, Input, AfterContentInit } from '@angular/core';
import { ConsentType } from '@core/services/cookie-consent/cookie-consent.config';
import { CookieConsentService } from '@core/services/cookie-consent/cookie-consent.service';
import { LoadScriptOptions } from '@core/services/load-scripts/load-scripts';
import { LoadScriptsService } from '@core/services/load-scripts/load-scripts.service';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { filter } from 'rxjs/operators';
import { PlatformService } from '@core/services/platform.service';

@UntilDestroy()
@Component({
    selector: 'app-third-party-loader',
    template: '',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true
})
export class ThirdPartyLoaderComponent implements AfterContentInit {
    @Input()
    private url: string;

    @Input()
    private scriptOptions?: LoadScriptOptions;

    @Input()
    private consent?: ConsentType;

    constructor(
        private platformService: PlatformService,
        private cookieConsentService: CookieConsentService,
        private loadScriptsService: LoadScriptsService
    ) {}

    ngAfterContentInit(): void {
        if (this.platformService.isServer) {
            return;
        }

        if (this.consent) {
            this.cookieConsentService.consentStatus$
                .pipe(
                    untilDestroyed(this),
                    filter(status => Boolean(status[this.consent as ConsentType]))
                )
                .subscribe(() => {
                    this.loadScriptsService.loadScript(this.url, this.scriptOptions);
                });
            return;
        }
    }
}
